/* =========================================================
   LOOOPS Edel – Warenkorb (Shopify Ajax API), Glücksrad,
   Quiz, Filter, Produktgalerie. Ohne Framework.
   ========================================================= */
(function () {
  "use strict";
  var L = window.LOOOPS || {};
  var R = L.routes || {};
  var TT = L.t || {};
  var tr = function (k, d) { return TT[k] || d; };
  var $ = function (s, el) { return (el || document).querySelector(s); };
  var $$ = function (s, el) { return Array.prototype.slice.call((el || document).querySelectorAll(s)); };
  var store = {
    get: function (k, d) { try { var v = localStorage.getItem(k); return v === null ? d : JSON.parse(v); } catch (e) { return d; } },
    set: function (k, v) { try { localStorage.setItem(k, JSON.stringify(v)); } catch (e) {} }
  };
  var money = function (cents) {
    try { return new Intl.NumberFormat(L.locale || "de", { style: "currency", currency: L.currency || "EUR" }).format(cents / 100); }
    catch (e) { return (cents / 100).toFixed(2).replace(".", ",") + " €"; }
  };
  var esc = function (s) { return String(s == null ? "" : s).replace(/[&<>"]/g, function (c) { return { "&": "&amp;", "<": "&lt;", ">": "&gt;", '"': "&quot;" }[c]; }); };
  var shortName = function (t) { var p = String(t || "").split(" - "); return p[1] || t; };

  /* ---------- Menü ---------- */
  var menuBtn = $(".menu-btn"), nav = $(".nav");
  if (menuBtn && nav) {
    menuBtn.addEventListener("click", function () {
      var open = nav.classList.toggle("open");
      menuBtn.setAttribute("aria-expanded", open ? "true" : "false");
      menuBtn.setAttribute("aria-label", open ? tr("menuClose", "Menü schließen") : tr("menuOpen", "Menü öffnen"));
    });
  }

  /* ---------- Toast ---------- */
  var toastEl, toastTimer;
  function toast(msg, withCart) {
    if (!toastEl) { toastEl = document.createElement("div"); toastEl.className = "toast"; toastEl.setAttribute("role", "status"); document.body.appendChild(toastEl); }
    toastEl.innerHTML = "<span>" + esc(msg) + "</span>" + (withCart ? '<button type="button">' + esc(tr("view", "Ansehen")) + '</button>' : "");
    var b = toastEl.querySelector("button"); if (b) b.addEventListener("click", openCart);
    toastEl.classList.add("show");
    clearTimeout(toastTimer); toastTimer = setTimeout(function () { toastEl.classList.remove("show"); }, 3200);
  }

  /* ---------- Warenkorb ---------- */
  var drawer = $("#cart-drawer"), backdrop = $(".drawer-backdrop");
  function code() { return store.get("looops_code", null); }
  function checkoutHref() { var c = code(); return "/checkout" + (c ? "?discount=" + encodeURIComponent(c) : ""); }
  function openCart() {
    if (!drawer) { location.href = R.cart || "/cart"; return; }
    refreshCart().then(function () {
      drawer.classList.add("open"); backdrop.classList.add("open"); drawer.setAttribute("aria-hidden", "false");
      var c = $(".drawer .icon-btn"); if (c) c.focus();
    });
  }
  function closeCart() {
    if (!drawer) return;
    drawer.classList.remove("open"); backdrop.classList.remove("open"); drawer.setAttribute("aria-hidden", "true");
  }
  function setCount(n) { $$("[data-cart-count]").forEach(function (el) { el.textContent = n; el.setAttribute("data-empty", n ? "false" : "true"); }); }
  function renderCart(cart) {
    setCount(cart.item_count);
    var body = $("[data-cart-body]"), foot = $("[data-cart-foot]");
    if (!body) return;
    if (!cart.item_count) {
      body.innerHTML = '<div class="drawer-empty"><p><strong>' + esc(tr("cartEmpty", "Dein Warenkorb ist noch leer.")) + '</strong></p><p class="muted">' + esc(tr("fromPrice", "LOOOPS ab 19,95 € pro Paar.")) + '</p><a class="btn" href="' + (R.shop || "/collections/all") + '">' + esc(tr("toShop", "Zum Shop")) + '</a></div>';
      foot.hidden = true; return;
    }
    foot.hidden = false;
    body.innerHTML = cart.items.map(function (it, i) {
      var parts = String(it.product_title || "").split(" - ");
      var img = it.image ? it.image + (it.image.indexOf("?") > -1 ? "&" : "?") + "width=200" : "";
      return '<div class="line-item" data-line="' + (i + 1) + '">' +
        '<a class="li-media" href="' + esc(it.url) + '">' + (img ? '<img src="' + esc(img) + '" alt="" width="76" height="76" loading="lazy">' : "") + "</a>" +
        "<div><h4><a href=\"" + esc(it.url) + "\">" + esc(parts[1] || it.product_title) + "</a></h4>" +
        '<div class="small muted">' + esc(parts[2] || it.variant_title || "") + "</div>" +
        '<div style="margin-top:8px"><span class="qty"><button type="button" data-q="-1" aria-label="' + esc(tr("qtyMinus", "Eins weniger")) + '">–</button><span>' + it.quantity + '</span><button type="button" data-q="1" aria-label="' + esc(tr("qtyPlus", "Eins mehr")) + '">+</button></span>' +
        '<button type="button" class="remove" data-q="0">' + esc(tr("remove", "Entfernen")) + '</button></div></div>' +
        "<strong>" + money(it.final_line_price) + "</strong></div>";
    }).join("");
    $("[data-cart-total]").textContent = money(cart.total_price);
    var c = code(), chip = $("[data-cart-code]");
    if (chip) { chip.hidden = !c; if (c) chip.textContent = tr("codeChip", "Code {code} wird an der Kasse eingelöst").replace("{code}", c); }
    var up = $("[data-cart-upsell]"); if (up) up.hidden = cart.item_count !== 1;
    $$("[data-checkout]").forEach(function (a) { a.setAttribute("href", checkoutHref()); });
  }
  function refreshCart() {
    return fetch((R.cart || "/cart") + ".js", { credentials: "same-origin", headers: { Accept: "application/json" } })
      .then(function (r) { return r.json(); }).then(function (c) { renderCart(c); return c; })
      .catch(function () {});
  }
  function changeLine(line, qty) {
    return fetch((R.cartChange || "/cart/change") + ".js", {
      method: "POST", credentials: "same-origin",
      headers: { "Content-Type": "application/json", Accept: "application/json" },
      body: JSON.stringify({ line: line, quantity: qty })
    }).then(function (r) { return r.json(); }).then(renderCart);
  }
  function addForm(form) {
    var btn = form.querySelector("[type=submit]");
    if (btn) btn.disabled = true;
    var fd = new FormData(form);
    return fetch((R.cartAdd || "/cart/add") + ".js", { method: "POST", credentials: "same-origin", headers: { Accept: "application/json" }, body: fd })
      .then(function (r) { return r.json().then(function (j) { if (!r.ok) throw j; return j; }); })
      .then(function (item) {
        toast(tr("added", "{name} liegt im Warenkorb").replace("{name}", shortName(item.product_title)), true);
        return refreshCart().then(function () { openCart(); });
      })
      .catch(function (err) { toast((err && (err.description || err.message)) || tr("error", "Das hat nicht geklappt. Bitte nochmal versuchen.")); })
      .then(function () { if (btn) btn.disabled = false; });
  }
  document.addEventListener("submit", function (e) {
    var f = e.target;
    if (f.classList && f.classList.contains("js-add")) { e.preventDefault(); addForm(f); }
  });
  document.addEventListener("click", function (e) {
    var t = e.target;
    if (t.closest("[data-cart-open]") && drawer) { e.preventDefault(); openCart(); return; }
    if (t.closest("[data-cart-close]")) { closeCart(); return; }
    var q = t.closest(".drawer [data-q]");
    if (q) {
      var li = q.closest("[data-line]"); var line = parseInt(li.getAttribute("data-line"), 10);
      var cur = parseInt(li.querySelector(".qty span").textContent, 10) || 0;
      var d = parseInt(q.getAttribute("data-q"), 10);
      changeLine(line, d === 0 ? 0 : Math.max(0, cur + d)); return;
    }
    var co = t.closest("[data-checkout]"); if (co) co.setAttribute("href", checkoutHref());
    var pq = t.closest("[data-qty]");
    if (pq) {
      var inp = pq.parentNode.querySelector("input");
      inp.value = Math.max(1, Math.min(20, (parseInt(inp.value, 10) || 1) + parseInt(pq.getAttribute("data-qty"), 10)));
      updateBuyNow();
    }
    var bn = t.closest("[data-buy-now]");
    if (bn) { updateBuyNow(); }
    var sa = t.closest("[data-sticky-add]");
    if (sa) { var pf = $("#pdp-form"); if (pf) addForm(pf); }
  });
  function updateBuyNow() {
    var bn = $("[data-buy-now]"), qi = $("#pdp-form input[name=quantity]");
    if (!bn) return;
    var url = "/cart/" + bn.getAttribute("data-buy-now") + ":" + (qi ? parseInt(qi.value, 10) || 1 : 1);
    var c = code(); if (c) url += "?discount=" + encodeURIComponent(c);
    bn.setAttribute("href", url);
  }
  updateBuyNow();
  document.addEventListener("keydown", function (e) { if (e.key === "Escape") { closeCart(); closePop(); } });
  if (drawer) refreshCart();

  /* ---------- Produktgalerie & Sticky-Kaufleiste ---------- */
  var gallery = $("[data-gallery]");
  if (gallery) {
    var main = gallery.querySelector(".gallery-main img");
    $$(".thumbs button", gallery).forEach(function (b) {
      b.addEventListener("click", function () {
        if (!main) return;
        main.removeAttribute("srcset"); main.src = b.getAttribute("data-src");
        main.classList.toggle("is-pack", b.getAttribute("data-pack") === "true");
        $$(".thumbs button", gallery).forEach(function (x) { x.setAttribute("aria-current", x === b ? "true" : "false"); });
      });
    });
  }
  var sticky = $("[data-sticky-buy]"), buyRow = $(".buy-row");
  if (sticky && buyRow && "IntersectionObserver" in window) {
    new IntersectionObserver(function (en) {
      var show = !en[0].isIntersecting && en[0].boundingClientRect.top < 0;
      sticky.classList.toggle("show", show); document.body.classList.toggle("has-sticky", show);
    }).observe(buyRow);
  }

  /* ---------- Shop-Filter ---------- */
  $$(".filters button").forEach(function (b) {
    b.addEventListener("click", function () {
      var f = b.getAttribute("data-filter");
      $$(".filters button").forEach(function (x) { x.setAttribute("aria-pressed", x === b ? "true" : "false"); });
      $$("[data-filter-grid] .card").forEach(function (c) { c.hidden = !(f === "alle" || c.getAttribute("data-kind") === f); });
    });
  });

  /* ---------- Quiz "Welcher LOOOP bist du?" ---------- */
  var quiz = $(".quiz"), qd = $("#quiz-data");
  if (quiz && qd) {
    var P = {}; try { P = JSON.parse(qd.textContent); } catch (e) {}
    var steps = $$(".quiz-step", quiz), score = {}, idx = 0;
    var show = function (n) { steps.forEach(function (s, i) { s.hidden = i !== n; }); };
    show(0);
    quiz.addEventListener("click", function (e) {
      var b = e.target.closest("[data-vote]"); if (!b) return;
      b.getAttribute("data-vote").split(" ").forEach(function (v) { score[v] = (score[v] || 0) + 1; });
      idx++;
      if (idx < steps.length - 1) { show(idx); return; }
      var best = Object.keys(score).sort(function (a, c) { return score[c] - score[a]; })[0];
      var p = P[best] || {}, res = steps[steps.length - 1];
      var text = (res.querySelector('[data-text="' + best + '"]') || {}).textContent || "";
      res.innerHTML = '<div class="progress">' + esc(tr("match", "Dein Match")) + '</div><div class="result"><div class="im">' + (p.img ? '<img src="' + esc(p.img) + '" alt="">' : "") + '</div><div><h3>' + esc(p.name || best) + '</h3><p class="small" style="margin:0">' + esc(text) + ' ' + esc(p.price || "") + '</p>' +
        '<div class="hero-ctas"><form class="js-add" action="/cart/add" method="post"><input type="hidden" name="id" value="' + esc(p.variant) + '"><button class="btn" type="submit">' + esc(tr("addToCart", "In den Warenkorb")) + '</button></form><a class="btn alt" href="' + esc(p.url || "#") + '">' + esc(tr("view", "Ansehen")) + '</a></div></div></div>';
      show(steps.length - 1);
    });
  }

  /* ---------- Glücksrad ---------- */
  var W = L.wheel || {};
  var segs = String(W.segments || "").split(/\r?\n/).map(function (l) {
    var p = l.split("|"); return p.length >= 2 ? { label: p[0].trim(), code: p[1].trim(), weight: parseFloat(p[2]) || 1 } : null;
  }).filter(Boolean);
  var COLORS = [["#111111", "#ffffff"], ["#f6f3ee", "#111111"], ["#7a1e2c", "#ffffff"], ["#ebe6de", "#111111"], ["#2b2926", "#ffffff"], ["#ffffff", "#7a1e2c"]];
  var modal = $("#wheel-modal"), giftTab = $(".gift-tab"), sheet = modal ? $("[data-sheet]", modal) : null;
  var onWheelPage = !!$(".wheel-box.inline");
  var inFrame = String(window.name || "").indexOf("wheel-sink") === 0; // Antwortseite im unsichtbaren Formular-Frame
  var touch = window.matchMedia && window.matchMedia("(pointer: coarse)").matches;
  var reduceMotion = window.matchMedia && window.matchMedia("(prefers-reduced-motion: reduce)").matches;
  var EMAIL_RE = /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/;

  function buildWheel(box) {
    var wheel = $(".wheel", box); if (!wheel || !segs.length) return;
    var n = segs.length, step = 360 / n;
    wheel.style.background = "conic-gradient(" + segs.map(function (s, i) {
      return COLORS[i % COLORS.length][0] + " " + (i * step) + "deg " + ((i + 1) * step) + "deg";
    }).join(",") + ")";
    segs.forEach(function (s, i) {
      var lab = document.createElement("span");
      lab.className = "wheel-label"; lab.textContent = s.label;
      lab.style.transform = "rotate(" + (i * step + step / 2) + "deg)";
      lab.style.color = COLORS[i % COLORS.length][1];
      wheel.appendChild(lab);
    });
  }
  function showResult(box, seg) {
    $(".wheel-step-1", box).hidden = true;
    var res = $(".wheel-step-2", box); res.hidden = false;
    $(".win-label", res).textContent = String(seg.label).replace(/ /g, " ");
    $("code", res).textContent = seg.code;
    box.classList.add("is-won");
  }
  function applyCode(c) {
    store.set("looops_code", c);
    // Shopify merkt sich den Code als Cookie und zieht ihn an der Kasse ab
    fetch("/discount/" + encodeURIComponent(c) + "?redirect=" + encodeURIComponent("/cart.js"), { credentials: "same-origin" }).catch(function () {});
    $$("[data-checkout]").forEach(function (a) { a.setAttribute("href", checkoutHref()); });
    updateBuyNow();
  }
  function pickSegment() {
    var total = segs.reduce(function (s, x) { return s + x.weight; }, 0), r = Math.random() * total;
    for (var i = 0; i < segs.length; i++) { r -= segs[i].weight; if (r <= 0) return i; }
    return 0;
  }
  function initWheel(box) {
    buildWheel(box);
    var won = store.get("looops_win", null);
    if (won) showResult(box, won);
    var form = $(".wheel-form", box); if (!form) return;
    var btn = $(".wheel-go", form), msg = $(".form-msg", form);
    var emailEl = form.querySelector("input[type=email]"), consentEl = $(".wheel-consent", form);
    var sinkEl = $(".wheel-sink", box), spun = false;
    // Formular landet im unsichtbaren Frame: Seite bleibt stehen, hCaptcha von Shopify bleibt aktiv
    if (sinkEl) form.setAttribute("target", sinkEl.getAttribute("name"));
    function fail(text, el) { msg.textContent = text; form.classList.add("has-error"); if (el) { el.focus({ preventScroll: true }); } }
    [emailEl, consentEl].forEach(function (el) { el.addEventListener("input", function () { msg.textContent = ""; form.classList.remove("has-error"); }); el.addEventListener("change", function () { msg.textContent = ""; form.classList.remove("has-error"); }); });
    if (touch && sheet && box.classList.contains("in-modal")) {
      emailEl.addEventListener("focus", function () { setTimeout(function () { btn.scrollIntoView({ block: "nearest", behavior: "smooth" }); }, 320); });
    }
    function spin() {
      var win = pickSegment(), step = 360 / segs.length, target = 360 * 6 + (360 - (win * step + step / 2));
      var wheel = $(".wheel", box);
      box.classList.add("is-spinning");
      btn.textContent = tr("spinning", "Das Rad dreht sich …");
      if (document.activeElement && document.activeElement.blur) document.activeElement.blur();
      var scroller = box.closest("[data-sheet]");
      if (scroller) scroller.scrollTo({ top: 0, behavior: reduceMotion ? "auto" : "smooth" });
      else if (box.getBoundingClientRect().top < 0) box.scrollIntoView({ behavior: reduceMotion ? "auto" : "smooth", block: "start" });
      wheel.style.transform = "rotate(" + target + "deg)";
      setTimeout(function () {
        box.classList.remove("is-spinning");
        store.set("looops_win", segs[win]);
        applyCode(segs[win].code);
        showResult(box, segs[win]);
        if (navigator.vibrate) { try { navigator.vibrate(40); } catch (e) {} }
        if (giftTab) giftTab.hidden = true;
      }, reduceMotion ? 60 : 4700);
    }
    // Klick (auch Enter im E-Mail-Feld) prüft, startet das Rad und lässt den Browser das Formular abschicken
    btn.addEventListener("click", function (e) {
      if (spun) { e.preventDefault(); return; }
      var email = emailEl.value.trim();
      if (!EMAIL_RE.test(email)) { e.preventDefault(); fail(tr("invalidEmail", "Bitte gib eine gültige E-Mail-Adresse ein."), emailEl); return; }
      if (!consentEl.checked) { e.preventDefault(); fail(tr("consentRequired", "Zum Mitspielen bitte das Häkchen setzen: Mit der Teilnahme meldest du dich zum Newsletter an."), null); consentEl.closest("label").classList.add("shake"); setTimeout(function () { consentEl.closest("label").classList.remove("shake"); }, 500); return; }
      emailEl.value = email;
      spun = true; msg.textContent = "";
      setTimeout(function () { btn.disabled = true; spin(); }, 0);
    });
    form.addEventListener("submit", function (e) { if (!spun) { e.preventDefault(); btn.click(); } });
    var cp = $(".copy-code", box);
    if (cp) cp.addEventListener("click", function () {
      var c = $(".wheel-step-2 code", box).textContent;
      try { navigator.clipboard.writeText(c).then(function () { cp.textContent = tr("copied", "Kopiert"); toast(tr("codeCopied", "Code kopiert:") + " " + c); }); } catch (err) {}
    });
  }
  if (!inFrame) $$("[data-wheel]").forEach(initWheel);

  function openPop() {
    if (!modal) return;
    if (onWheelPage) { var w = $(".wheel-box.inline"); if (w) w.scrollIntoView({ behavior: "smooth", block: "center" }); return; }
    if (sheet) { sheet.style.transform = ""; sheet.scrollTop = 0; }
    modal.hidden = false; document.documentElement.classList.add("pop-open");
    // Spam-Schutz von Shopify (hCaptcha) erst beim Öffnen verbinden, damit das Logo nicht auf jeder Seite hängt
    var mf = $("#wheel-modal .wheel-form");
    if (mf && !mf.getAttribute("data-protected") && window.Shopify && window.Shopify.captcha && window.Shopify.captcha.protect) { mf.setAttribute("data-protected", "1"); try { window.Shopify.captcha.protect(mf); } catch (e) {} }
    if (giftTab) giftTab.hidden = true;
    var f = $("#wheel-modal input[type=email]");
    // Auf dem Handy nicht sofort die Tastatur aufklappen, sonst ist das Rad verdeckt
    if (f && !touch && !store.get("looops_win", null)) setTimeout(function () { f.focus({ preventScroll: true }); }, 80);
  }
  function closePop() {
    if (!modal || modal.hidden) return;
    modal.hidden = true; document.documentElement.classList.remove("pop-open");
    if (sheet) sheet.style.transform = "";
    store.set("looops_pop_snooze", Date.now());
    if (giftTab && !store.get("looops_win", null)) giftTab.hidden = false;
  }
  window.LOOOPS.openWheel = openPop;
  document.addEventListener("click", function (e) {
    var b = e.target.closest("[data-open-wheel]");
    if (b && modal && !onWheelPage) { e.preventDefault(); openPop(); }
  });
  if (modal && !inFrame) {
    $(".modal-close", modal).addEventListener("click", closePop);
    modal.addEventListener("click", function (e) { if (e.target === modal) closePop(); });
    // Bottom-Sheet auf dem Handy nach unten wegwischen
    var drag = $("[data-sheet-drag]", modal), y0 = null, dy = 0;
    if (sheet && drag) {
      drag.addEventListener("touchstart", function (e) { if (sheet.scrollTop > 0 || modal.querySelector(".is-spinning")) return; y0 = e.touches[0].clientY; dy = 0; sheet.classList.add("dragging"); }, { passive: true });
      drag.addEventListener("touchmove", function (e) { if (y0 === null) return; dy = Math.max(0, e.touches[0].clientY - y0); sheet.style.transform = "translateY(" + dy + "px)"; }, { passive: true });
      drag.addEventListener("touchend", function () { if (y0 === null) return; sheet.classList.remove("dragging"); y0 = null; if (dy > 110) closePop(); else sheet.style.transform = ""; });
    }
    var hasWin = !!store.get("looops_win", null);
    var designMode = window.Shopify && window.Shopify.designMode;
    if (W.enabled && segs.length && !hasWin && !onWheelPage && !designMode) {
      var snooze = store.get("looops_pop_snooze", 0);
      var snoozed = snooze && (Date.now() - snooze) < (W.snooze || 5) * 864e5;
      if (snoozed) { if (giftTab) giftTab.hidden = false; }
      else {
        var fired = false;
        var fire = function () {
          if (fired) return; fired = true;
          window.removeEventListener("scroll", onScroll); document.removeEventListener("mouseout", onLeave);
          var busy = (drawer && drawer.classList.contains("open")) || (nav && nav.classList.contains("open")) || document.visibilityState === "hidden";
          if (!busy) openPop(); else if (giftTab) giftTab.hidden = false;
        };
        var onScroll = function () { var h = document.documentElement.scrollHeight - innerHeight; if (h > 0 && scrollY / h > 0.4) fire(); };
        var onLeave = function (e) { if (!e.relatedTarget && e.clientY <= 0) fire(); };
        setTimeout(fire, (W.delay || 10) * 1000);
        window.addEventListener("scroll", onScroll, { passive: true });
        if (!touch) document.addEventListener("mouseout", onLeave);
      }
    } else if (giftTab && !hasWin && !onWheelPage && W.enabled) { giftTab.hidden = false; }
  }
})();
